<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="店铺名称" prop="shop_id" v-if="shops.length > 0">
                <el-select
                    v-model="queryForm.shop_id"
                    filterable
                    remote
                    clearable
                    :remote-method="remoteShopMethod"
                    placeholder="请输入店铺">
                    <el-option
                        v-for="item in shopList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始日期" prop="startDate1">
                <el-date-picker
                    v-model="queryForm.startDate1"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="endDate1">
                <el-date-picker
                    v-model="queryForm.endDate1"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-card class="box-card mb20" style="background-color: #eaf5fc">
            <el-row>
                <el-col :span="8">
                    <div>
                        总营业流水（剔除退款）
<!--                        <div  style="display: inline-block;position: relative">-->
<!--                            <el-tooltip class="item" effect="dark" content="总收款流水＝校方收款流水+公司收款流水" placement="right">-->
<!--                                <i class="el-icon-warning"></i>-->
<!--                            </el-tooltip>-->
<!--                        </div>-->
                    </div>
                    <p class="red f12">＋<span class="f20 plr2">{{summary.totalBillAmount || 0}}</span>元</p>
<!--                    <p class="c6">{{summary.totalOrderSum || 0}}单</p>-->
                </el-col>
                <el-col :span="8">
                    <div>
                        总订单数
                    </div>
                    <p class="c6">{{summary.totalOrderSum || 0}}单</p>
                </el-col>
            </el-row>
        </el-card>
        <el-row class="pb20" v-if="affiliation_level == 1 || affiliation_level == 2">
            <export-excel :params="exportParams" :action="$apiUrl.financeShopBill" :target="'finance'" :field="field" :filename="fileName" :fieldname="fieldName"></export-excel>
        </el-row>
        <!--table-->
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                prop="id"
                label="序号"
                width="80">
            </el-table-column>
            <el-table-column
                prop="businessDate"
                label="日期"
                width="130">
                <template slot-scope="scope">
                    <span>{{$utils.formatDate1(scope.row.businessDate)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="shopName"
                label="店铺名称"
                :show-overflow-tooltip="true"
                width="160">
            </el-table-column>
            <el-table-column
                prop="billAmount"
                label="营业收入（元）"
                width="130">
            </el-table-column>
            <el-table-column
                prop="orderSum"
                label="订单数"
                width="100">
            </el-table-column>
            <el-table-column
                prop="expenseAmount"
                label="退款金额（元）"
                width="130">
            </el-table-column>
            <el-table-column
                prop="expenseSum"
                label="退款订单数"
                width="100">
            </el-table-column>
            <el-table-column
                prop="realIncomeAmount"
                label="实际营业收入（剔除退款）"
                width="130">
            </el-table-column>
            <el-table-column
                prop="realOrderSum"
                label="订单数（剔除退款）"
                width="100">
            </el-table-column>
<!--            <el-table-column-->
<!--                prop="checkoutType"-->
<!--                label="收款方式"-->
<!--                width="120">-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.checkoutType==1">学校</span>-->
<!--                    <span v-if="scope.row.checkoutType==2">公司</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                prop="payType"-->
<!--                label="打款方式"-->
<!--                :show-overflow-tooltip="true"-->
<!--                width="">-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.payType==0">财务打款</span>-->
<!--                    <span v-if="scope.row.payType==1">财务打款</span>-->
<!--                    <span v-if="scope.row.payType==2">支付宝</span>-->
<!--                    <span v-if="scope.row.payType==3">银联转账</span>-->
<!--                    <span v-if="scope.row.payType==4">钱包提现</span>-->
<!--                    <span v-if="scope.row.payType==5">支付宝直付通打款</span>-->
<!--                    <span v-if="scope.row.payType==6">快钱分账</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                prop=""
                label="操作"
                fixed="right"
                width="120">
                <template slot-scope="scope">
                    <el-button type="text" @click="view(scope.row)" size="mini">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import moment from 'moment'
import ExportExcel from "../../components/exportExcel2.vue";
export default {
    components: {ExportExcel},
    data() {
        return {
            queryFormLabelWidth: '100px',//自定义查询表单label宽度
            queryForm: {//查询表单数据
                pageSize: 10,
                pageNo: 1,
                startTime: '',
                endTime: '',
                startDate1: '',
                endDate1: '',
                // dateRange: [],
                // commercial_id: '',
                //commercial_idList: '',
                shop_id: '',
                //shop_idList: '',
                for_report: true
            },

            tableData: [],//表格数据
            total: 0,//总数
            pageSizes: [10,20,30,40,50],//自定义分页条数
            multipleSelection: [],//table选中项
            loading: true,//表格是否显示加载效果

            // commercials: [],
            shops: [],
            shopList: [],
            summary: {},
            affiliation_level: 0, //1,2级别可以下载数据 3不可以
            //导出
            exportParams: {},
            fileName: '店铺数据表',
            fieldName: ['序号','日期','店铺名称','营业收入（元）','订单数','退款金额（元）','退款订单数','实际营业收入（剔除退款）','订单数（剔除退款）'],
            field: ['id','businessDate','shopName','billAmount','orderSum','expenseAmount','expenseSum','realIncomeAmount','realOrderSum']
        }
    },
    created(){
        var day = new Date();
        this.queryForm.endDate1 = day.setTime(day.getTime());
        day.setTime(day.getTime()-7*24*60*60*1000);
        this.queryForm.startDate1 = day;
        // this.commercials = JSON.parse(localStorage.getItem('commercials'));
        this.shops = JSON.parse(localStorage.getItem('shops'));
        this.affiliation_level = JSON.parse(localStorage.getItem('accountInfo')).affiliation_level;
        if(this.$route.query.id){
            // this.queryForm.commercial_id = this.$route.query.id;
            this.getShopList();
        }
        this.fetchData();
    },
    methods: {
        //抓取列表数据
        fetchData() {
            this.getSummary();
            this.getTableData();
        },
        getParams() {
            let params = {...this.queryForm};
            params.startTime = moment(params.startDate1).format('YYYYMMDD');
            params.endTime = moment(params.endDate1).format('YYYYMMDD');
            return params;
        },
        getSummary() {
            let params = this.getParams();
            delete params.pageSize;
            delete params.pageNo;
            this.$apiJava.post(this.$apiUrl.financeShopBillSummary,params,(res)=>{
                this.summary = res.data || {};
            },null,'finance')
        },
        getTableData() {
            let params = this.getParams();
            this.exportParams = {...params};
            this.exportParams.pageNo = 1;
            this.exportParams.pageSize = 99999;

            this.$apiJava.post(this.$apiUrl.financeShopBill,params,(res)=>{
                this.loading = false;
                this.total = res.data.total || 0;
                this.tableData = res.data.list || [];
            },(res)=>{
                this.$message.warning(res.message);
                this.loading = false;
                this.tableData = [];
            },'finance')
        },
        //获取公司下的店铺
        getShopList() {
            this.queryForm.shop_id = '';
            this.shopList = [];
            this.$api.get(this.$apiUrl.getShopList,{commercial_id: this.queryForm.commercial_id,page: 1,pageSize: 50},(res)=>{
                if(res.data){
                    for(let k in res.data){
                        this.shopList.push({id:k,name:res.data[k]});
                    }
                }else {
                    this.shopList = [];
                }
            })
        },
        //查看
        view(item) {
            this.$router.push({name: 'SaasOrderData', params: { id: item.shopId, date: this.$utils.formatDate1(item.businessDate)}});
        },
        remoteShopMethod(query){
            if (query !== '') {
                this.shopList = [];
                var arr = [];
                let len = this.shops.length;
                var reg = new RegExp(query);
                for(var i=0;i<len;i++){
                    //如果字符串中不包含目标字符会返回-1
                    if(this.shops[i].name.match(reg)){
                        this.shopList.push(this.shops[i]);
                    }
                }
            } else {
                this.shopList = [];
            }
        },
        //表单重置 item上需要添加prop属性
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.shopList = [];
            // this.queryForm.commercial_id = '';
//                this.queryForm.dateRange = [];
        },
        //切换每页显示条数操作
        handleSizeChange(val) {
            this.queryForm.pageSize = val;
            this.getTableData();
        },
        //切换页码操作
        handleCurrentChange(val) {
            this.queryForm.pageNo = val;
            this.getTableData();
        }
    }
}
</script>
<style lang="scss"  scoped>
.el-card{
    border: none;
    box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// shopData.vue?d55e5dd6